export const UI_COPY = {
  navigation: {
    backToMenu: 'Menu',
    help: 'Help',
  },
  editor: {
    buildTrack: 'Build Track',
    editPiece: 'Edit Piece',
    editShape: 'Edit Shape',
    rideCheck: 'Ride Check',
    rideSummary: 'Ride Summary',
    jumpToTrack: 'Jump to Track',
    ready: 'Ready to Ride',
    saveDraft: 'Save Draft',
    testRide: 'Test Ride',
    recordRide: 'Record Ride',
    publish: 'Publish to Buncha Games',
    shareRide: 'Share Ride',
  },
  publish: {
    title: 'Publish to Buncha Games',
    previewTitle: 'Buncha Games Preview',
    previewDescription:
      'Players see this image while browsing. A muted motion preview appears on hover when available.',
    capturePreview: 'Capture Preview Image',
    replacePreview: 'Replace Preview',
    autoFrame: 'Auto-Frame',
    autoFrameAgain: 'Auto-Frame Again',
    saveGateTitle: 'Save this coaster first',
    saveGateDescription: 'Save your draft before publishing.',
    saveAndContinue: 'Save Draft & Continue',
    keepEditing: 'Keep Editing',
  },
  media: {
    title: 'Ride Media',
    create: 'Create Ride Media',
    photo: 'Action Photo',
    video: 'Video',
    previewImage: 'Coaster Overview',
    shortLoop: 'Short Loop',
    enableCamera: 'Enable Camera',
  },
} as const;
